import { Observable, Subject } from 'rxjs'

import { Injectable } from '@angular/core'

export enum SnackbarEventType {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  SUCCESS = 'SUCCESS',
  INFO = 'INFO',
}

export const SNACKBAR_LENGTH_LONG = 6000
export const SNACKBAR_LENGTH_SHORT = 3500

export class SnackbarEvent {
  message: string
  permanent: boolean
  timeout: number
  eventType: SnackbarEventType
  prioritised: boolean

  constructor(message: string, permanent: boolean, timeout: number, eventType: SnackbarEventType, privileged = false) {
    this.message = message
    this.permanent = permanent
    this.timeout = timeout
    this.eventType = eventType
    this.prioritised = privileged
  }
}

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  visible = false

  private eventSubject = new Subject<any>()
  private hideSubject = new Subject<any>()

  showSnackbar(message: string, timeoutMs: number, eventType: SnackbarEventType) {
    const event = new SnackbarEvent(message, false, timeoutMs, eventType, false)
    this.eventSubject.next(event)
  }

  showPrioritisedSnackbar(message: string, timeoutMs: number, eventType: SnackbarEventType) {
    const event = new SnackbarEvent(message, false, timeoutMs, eventType, true)
    this.eventSubject.next(event)
  }

  showDefaultErrorSnackbar() {
    const event = new SnackbarEvent(
      'Something went wrong. Please try again',
      false,
      SNACKBAR_LENGTH_LONG,
      SnackbarEventType.ERROR,
      false
    )
    this.eventSubject.next(event)
  }

  showPermanentSnackbar(message: string, eventType: SnackbarEventType) {
    const event = new SnackbarEvent(message, true, 0, eventType)
    this.eventSubject.next(event)
  }

  showErrorSnackbar(message: string, timeoutMs: number = SNACKBAR_LENGTH_LONG) {
    this.showSnackbar(message, timeoutMs, SnackbarEventType.ERROR)
  }

  showSuccessSnackbar(message: string, timeoutMs: number = SNACKBAR_LENGTH_LONG) {
    this.showSnackbar(message, timeoutMs, SnackbarEventType.SUCCESS)
  }

  showInfoSnackbar(message: string, timeoutMs: number = SNACKBAR_LENGTH_LONG) {
    this.showSnackbar(message, timeoutMs, SnackbarEventType.INFO)
  }

  showWarningSnackbar(message: string, timeoutMs: number = SNACKBAR_LENGTH_LONG) {
    this.showSnackbar(message, timeoutMs, SnackbarEventType.WARNING)
  }

  hide() {
    this.hideSubject.next(true)
  }

  getEvent(): Observable<any> {
    return this.eventSubject.asObservable()
  }

  getHideEvent(): Observable<any> {
    return this.hideSubject.asObservable()
  }
}
